import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'state/global-state/store';

export const selectContentCards = ({ loyalty }: RootState) => loyalty.contentCards.contentCards;

export const selectNewsFeedContentCards = ({ loyalty }: RootState) =>
  loyalty.contentCards.newsFeedContentCards;

export const selectHomePageFeedContentCards = ({ loyalty }: RootState) =>
  loyalty.contentCards.homePageFeedContentCards;

export const selectWebContentCards = ({ loyalty }: RootState) =>
  loyalty.contentCards.webContentCards;

export const selectContentCardsLoaded = ({ loyalty }: RootState) =>
  loyalty.contentCards.contentCardsLoaded;

export const selectServerReadNotificationIds = ({ loyalty }: RootState) =>
  loyalty.contentCards.serverReadNotificationIds;

export const selectServerReadStatus = ({ loyalty }: RootState) =>
  loyalty.contentCards.serverReadStatus;

export const selectResolvedNotificationIds = ({ loyalty }: RootState) =>
  loyalty.contentCards.resolvedNotificationIds;

export const selectNotificationCenterSessionOwnerId = ({ loyalty }: RootState) =>
  loyalty.contentCards.sessionOwnerId;

export const selectLocalReadsSyncStatus = ({ loyalty }: RootState) =>
  loyalty.contentCards.localReadsSyncStatus;

export const selectLocalReadsVersion = ({ loyalty }: RootState) =>
  loyalty.contentCards.localReadsVersion;

export const selectNotificationCenterSessionId = ({ loyalty }: RootState) =>
  loyalty.contentCards.sessionId;

export const selectBrazeContentCards = createSelector(
  selectContentCards,
  selectNewsFeedContentCards,
  selectHomePageFeedContentCards,
  selectWebContentCards,
  (contentCards, newsFeedContentCards, homePageFeedContentCards, webContentCards) => {
    return {
      contentCards: contentCards || [],
      newsFeedContentCards: newsFeedContentCards || [],
      homePageFeedContentCards: homePageFeedContentCards || [],
      webContentCards: webContentCards || [],
    };
  }
);
